import { useSpring } from '@react-spring/web';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from '../../../app/store';
import { useWindowSize } from '../../../app/hooks/useWindowSize';
import cn from '../../../app/utils/cn';

export function useNavItemController() {
  const { sidebarIsOpen } = useStore(
    useShallow((state) => ({ sidebarIsOpen: state.sidebar.isOpen })),
  );
  const { isMobile } = useWindowSize();
  const navItemAnimation = useSpring({
    width: '100%',
    config: { duration: 200, tension: 280, friction: 120 },
  });

  const cnSelected = useMemo(() => {
    return cn(
      'text-green-600 dark:text-green-400 bg-grey-0/50 dark:bg-grey-700/50 font-bold shadow animation-[width_1s_ease-in-out]',
    );
  }, []);

  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);

  const showTooltip = useCallback(() => {
    setIsTooltipVisible(true);
  }, []);

  const hideTooltip = useCallback(() => {
    setIsTooltipVisible(false);
  }, []);

  useEffect(() => {
    if (sidebarIsOpen || isMobile) {
      setIsTooltipVisible(false);
    }
  }, [sidebarIsOpen, isMobile]);

  return {
    cnSelected,
    navItemAnimation,
    isTooltipVisible: isTooltipVisible && !isMobile,
    sidebarIsOpen,
    showTooltip,
    hideTooltip,
  };
}
